import React from 'react';
import  {IndexLink,Link} from 'react-router';


export default class HeaderComponent extends React.Component{
	render() {
    return (
    	<header className="page_header">
    	  <Link to="/"><p className="page_header_title">
			{this.props.title}
		</p></Link>
		
		<ul className="page_header_login">
			<li className="login">
				<Link to="/signin">Log in</Link>
			</li>
			<li className="signup">
			<Link to="/signup">Sign up</Link>
				
			</li>
		</ul>
	</header>
      
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/commons/header.js
 **/